import React from "react";
import removeImg from "assets/svgs/close.svg";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { numInputValidations } from "helpers/functions";

const SlidersArray = ({ sliders, setSliders }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newSlidersArray = sliders?.map((slider, index) => {
      if (index !== id) return slider;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...slider,
          [inputName]: {
            ...slider?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...slider, [name]: value };
    });

    setSliders(newSlidersArray);
  };

  return (
    <div className="form-group branches sliders">
      <Row style={{ rowGap: "10px" }}>
        <h5>
          <FormattedMessage id={"statistics"} />
        </h5>

        {sliders?.map((slider, index) => {
          return (
            <Row key={index} className="">
              <div className="add-multi-component">
                <Row style={{ rowGap: "10px" }}>
                  <Row>
                    <Col lg={6}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"title"} /> ({" "}
                          <FormattedMessage id={"arabic-language"} /> )
                        </h5>
                        <input
                          type="title"
                          name={"title.ar"}
                          className="form-control form-outline"
                          onChange={(e) => handleInputOnChange(e, index)}
                          value={slider?.title.ar}
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"title"} /> ({" "}
                          <FormattedMessage id={"english-language"} /> )
                        </h5>
                        <input
                          type="title"
                          name={"title.en"}
                          className="form-control form-outline"
                          onChange={(e) => handleInputOnChange(e, index)}
                          value={slider?.title.en}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"count"} />
                      </h5>
                      <input
                        type="count"
                        name={"count"}
                        className="form-control form-outline"
                        onChange={(e) => handleInputOnChange(e, index)}
                        value={slider?.count}
                        {...numInputValidations}
                      />
                    </div>
                  </Row>
                </Row>
              </div>
            </Row>
          );
        })}
      </Row>
    </div>
  );
};

export default SlidersArray;
